import React, { Component } from 'react'
import { Panel } from 'primereact/panel'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import './ImportTrechoMassa.css'
import {
  Btn,
  CentraisOperacaoDropdown,
  ExcelModeloBuilder,
  ImportExcelFile,
  PageHeader,
  TextBtn,
} from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { saveStepsMassively } from '../../../../services/api/https/system/system.http'

class ImportTrechoMassa extends Component {
  modeloExcel = [
    ['cnpj', 'trecho_um_tp_id', 'trecho_dois_tp_id', 'trecho_tres_tp_id', 'trecho_quatro_tp_id'],
  ]
  state = {
    loading: true,
    trechos: [],
    operationcenter_id: '',
  }
  onBtnSalvarClicked = async () => {
    try {
      const { operationcenter_id } = this.state
      if (operationcenter_id === '') {
        throw new Error('Selecione o Centro de Operações')
      } else {
        this.setState({ loading: true })
        const { trechos } = this.state
        if (trechos.length === 0) {
          throw new Error('Não existem Trechos para Importação')
        }

        const message = await saveStepsMassively(trechos)
        this.props.dispatch(showMessageBox(message, null))
        this.setState({ loading: false, trechos: [] })
      }
    } catch (error) {
      this.setState({ loading: false })
      this.props.dispatch(showMessageBox(null, errorHandler(error)))
    }
  }
  onBtnVoltarClicked = () => {
    this.props.history.goBack()
  }
  onFileImported = content => {
    try {
      const isPlanilhaNoPadrao = this._planilhaNoPadrao(content)
      if (!isPlanilhaNoPadrao) {
        throw new Error('Planilha Fora do Padrão. Baixe o Modelo e Verifique.')
      }
      this.setState({ trechos: this._buildTrechos(content) })
    } catch (error) {
      this.props.dispatch(showMessageBox(null, error.message))
    }
  }
  onCentroOperacoesChange = value => {
    try {
      const { trechos } = this.state
      trechos.forEach(t => (t.operationcenter_id = value))
      this.setState({ operationcenter_id: value, trechos })
    } catch (error) {
      this.props.dispatch(showMessageBox(null, errorHandler(error)))
    }
  }
  render() {
    const { trechos, operationcenter_id } = this.state
    return (
      <div>
        <PageHeader>
          <span>S.9 - Importação da Associação Cliente x Trechos</span>
        </PageHeader>
        <div style={{ marginTop: 20 }}>
          <Panel>
            <div className="p-grid">
              <div className="p-col-3">
                <CentraisOperacaoDropdown
                  value={operationcenter_id}
                  onChange={id => this.onCentroOperacoesChange(id)}
                />
              </div>
              <div className="p-col-9">
                <div style={{ display: 'inline-block', marginLeft: 10 }}>
                  <ExcelModeloBuilder
                    modeloColunas={this.modeloExcel}
                    filename="ImportaoAssocClienteTrecho.xlsx"
                  />
                </div>
                <div style={{ display: 'inline-block', marginLeft: 10 }}>
                  <ImportExcelFile
                    label="Importar"
                    classes="btnImportar"
                    onFileImported={this.onFileImported}
                  />
                </div>

                <div style={{ display: 'inline-block', marginLeft: 10 }}>
                  <Btn onClick={this.onBtnSalvarClicked}>Salvar</Btn>
                </div>
                <div style={{ display: 'inline-block', marginLeft: 10 }}>
                  <TextBtn onClick={this.onBtnVoltarClicked}>Voltar</TextBtn>
                </div>
              </div>
            </div>
            <div>
              <DataTable value={trechos} emptyMessage="Nenhum Trecho Encontrado">
                <Column field="cnpj" header="CNPJ" style={tableCellCentered()} />
                <Column
                  field="operationcenter_id"
                  header="Cod. Centro Operações"
                  style={tableCellCentered(80)}
                />
                <Column field="step_1" header="Trecho Um" style={tableCellCentered()} />
                <Column field="step_2" header="Trecho Dois" style={tableCellCentered()} />
                <Column field="step_3" header="Trecho Três" style={tableCellCentered()} />
                <Column field="step_4" header="Trecho Quatro" style={tableCellCentered()} />
              </DataTable>
            </div>
          </Panel>
        </div>
      </div>
    )
  }
  // Helpers
  _planilhaNoPadrao = content => {
    const header = content[0]
    return (
      header[0] === 'cnpj' &&
      header[1] === 'trecho_um_tp_id' &&
      header[2] === 'trecho_dois_tp_id' &&
      header[3] === 'trecho_tres_tp_id' &&
      header[4] === 'trecho_quatro_tp_id'
    )
  }
  _buildTrechos = content => {
    const body = content.splice(1)
    const { operationcenter_id } = this.state
    const result = []
    for (let index = 0; index < body.length; index++) {
      const row = body[index]
      if (!row[0] || !row[1]) {
        throw new Error(`Erro próximo a linha ${index} da planilha. Conteúdo inconsistente.`)
      }
      result.push({
        cnpj: row[0].toString(),
        operationcenter_id,
        step_1: row[1],
        step_2: row[2],
        step_3: row[3],
        step_4: row[4],
      })
    }
    return result
  }
}
export default connect()(withRouter(ImportTrechoMassa))
